interface IIcon {
  width?: string;
  height?: string;
}
const TextFileIcon = ({ width = '16', height = '16' }: IIcon) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.39999 20.4008C2.39999 21.0636 2.93719 21.6008 3.59999 21.6008H5.19999V18.8008H3.19999C3.19999 18.8008 2.39999 18.8008 2.39999 20.4008Z"
      fill="#4B84DD"
    />
    <path
      d="M21.6 4.80039V22.0004C21.6 22.884 20.8836 23.6004 20 23.6004H6.4C5.5164 23.6004 4.8 22.884 4.8 22.0004V2.00039C4.8 1.11679 5.5164 0.400391 6.4 0.400391H17.2L21.6 4.80039Z"
      fill="#E8ECEF"
    />
    <path
      d="M21.6 4.80039H17.6C17.38 4.80039 17.2 4.62039 17.2 4.40039V0.400391L21.6 4.80039Z"
      fill="#C7D0DD"
    />
    <path
      d="M3.59999 19.1992H18C18.6628 19.1992 19.2 18.662 19.2 17.9992V12.3992C19.2 11.7364 18.6628 11.1992 18 11.1992H3.59999C2.93719 11.1992 2.39999 11.7364 2.39999 12.3992V20.3992C2.39999 19.7364 2.93719 19.1992 3.59999 19.1992Z"
      fill="#69ADFE"
    />
    <path
      d="M8 12.8008H5.6C5.3788 12.8008 5.2 12.9796 5.2 13.2008C5.2 13.422 5.3788 13.6008 5.6 13.6008H6.4V17.2008C6.4 17.422 6.5788 17.6008 6.8 17.6008C7.0212 17.6008 7.2 17.422 7.2 17.2008V13.6008H8C8.2212 13.6008 8.4 13.422 8.4 13.2008C8.4 12.9796 8.2212 12.8008 8 12.8008Z"
      fill="white"
    />
    <path
      d="M12.206 12.8578C12.0164 12.7442 11.7708 12.8058 11.6572 12.995L10.8 14.4234L9.9428 12.995C9.8292 12.8058 9.584 12.7442 9.394 12.8578C9.2044 12.9714 9.1432 13.217 9.2568 13.4066L10.3332 15.2006L9.2568 16.9946C9.1432 17.1842 9.2044 17.4298 9.394 17.5434C9.4584 17.5822 9.5296 17.6006 9.5996 17.6006C9.7356 17.6006 9.868 17.5314 9.9428 17.4066L10.8 15.9782L11.6572 17.4066C11.7324 17.5314 11.8648 17.6006 12.0004 17.6006C12.0704 17.6006 12.1416 17.5822 12.206 17.5434C12.3956 17.4298 12.4568 17.1842 12.3432 16.9946L11.2668 15.2006L12.3432 13.4066C12.4568 13.217 12.3956 12.9714 12.206 12.8578Z"
      fill="white"
    />
    <path
      d="M16 12.8008H13.6C13.3788 12.8008 13.2 12.9796 13.2 13.2008C13.2 13.422 13.3788 13.6008 13.6 13.6008H14.4V17.2008C14.4 17.422 14.5788 17.6008 14.8 17.6008C15.0212 17.6008 15.2 17.422 15.2 17.2008V13.6008H16C16.2212 13.6008 16.4 13.422 16.4 13.2008C16.4 12.9796 16.2212 12.8008 16 12.8008Z"
      fill="white"
    />
  </svg>
);

export default TextFileIcon;
